export const fmtDataSimples = new Intl.DateTimeFormat("pt-BR");
